import React, { useEffect } from 'react';
import { Button, Modal } from 'antd';
import "../../assets/css/app.scss"
import { toast } from 'react-toastify';
import { useFetch } from '../../Services/useFetch';


const Delete = (props) => {

  const { title, open, onClose, modalData2, fetchBriefFolderList, userInfo, socket } = props
  const notify = (error) => toast.error(error);
  const notifySuccess = (msg) => toast.success(msg);
  const { request } = useFetch();

  const innerFolderDelete = async () => {
    const isArray = Array.isArray(modalData2);

    const folderIds = isArray
      ? modalData2.filter(item => item.type === "folder").map(item => item.key).join(",")
      : modalData2?.type === "folder" ? modalData2.key : "";

    const fileIds = isArray
      ? modalData2.filter(item => item.type === "file").map(item => item.key).join(",")
      : modalData2?.type === "file" ? modalData2.key : "";

    const formData = new URLSearchParams();
    formData.append('folder_ids', folderIds);
    formData.append('files_ids', fileIds);

    try {
      const response = await request('/folder-file-delete', 'delete', formData, { 'Content-Type': "application/x-www-form-urlencoded" })

      const parentId = isArray ? modalData2[0]?.parent_id : modalData2?.parent_id;

      if (response?.data?.status === '1') {
      await fetchBriefFolderList(parentId);
        socket.emit("directory-action", { userName: userInfo?.userfullname, action: "Delete", });
        onClose()
      } else {
        notify(response?.response?.data?.message);
        onClose()
      }
    } catch (error) {
      await fetchBriefFolderList(isArray ? modalData2[0]?.parent_id : modalData2?.parent_id);
      onClose()
      console.log(error);
    }
  };

  useEffect(() => {
    socket.on("directory-action", ({ userName, action }) => {
      // notifySuccess(`${userName} has ${action} a directory.`);
    });

    return () => {
      socket.off("directory-action");
    };
  }, []);

  return (

    <Modal
      className="bd_delete_model"
      open={open}
      onCancel={onClose}
      footer={[
        <Button className='BG_ghostButton' key="cancel" onClick={onClose}>
          Cancel
        </Button>,
        <Button className='BG_deleteButton' key="delete" onClick={innerFolderDelete}>
          Delete
        </Button>
      ]}
    >
      <div className='bd_delete_container'>
        <span className='bd_delete_spn'>Are you sure you want to delete this {title?.toLowerCase()}</span>
        <p>If you delete the {title?.toLowerCase()}, you can't recover it.</p>
      </div>
    </Modal>
  )
}

export default Delete;

